import { useTranslation } from "react-i18next";

export const useConceptoGeocerca = () => {
    const { t } = useTranslation();
    const CONCEPTO_GEOCERCA = [
        { value: 2, label: t("label_grupo_geocerca_cliente") },
        { value: 3, label: t("label_grupo_geocerca_ciudades") },
        { value: 4, label: t("label_grupo_geocerca_georuta") },
        // { value: 5, label: t("label_grupo_geocerca_viaje") },
        // { value: 9, label: t("label_grupo_geocerca_clientes") },
        { value: 10, label: t("label_grupo_geocerca_depositos") },
    ];
    return CONCEPTO_GEOCERCA;
};
